<template>
  <div class="prizes-2021-prizes-list">
    <div
      class="prizes-2021-prizes-list__item"
      v-for="item in list"
      :key="item.id"
    >
      <Prizes2021PrizeItem :prize="item" />
    </div>
  </div>
</template>

<script>
import Prizes2021PrizeItem from "./Prizes2021PrizeItem";

export default {
  name: "Prizes2021PrizesList",
  components: {
    Prizes2021PrizeItem
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
.prizes-2021-prizes-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -10px;

  &__item {
    padding: 10px;
  }
}
</style>
